'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var sizes = {
  xxxs: {
    fontSize: '1.4rem',
    lineHeight: '2.0rem'
  },
  xxs: {
    fontSize: '1.6rem',
    lineHeight: '2.2rem'
  },
  xs: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem'
  },
  sm: {
    fontSize: '2rem',
    lineHeight: '2.6rem'
  },
  md: {
    fontSize: '2.4rem',
    lineHeight: '3.0rem'
  },
  lg: {
    fontSize: '3.0rem',
    lineHeight: '3.6rem'
  },
  xl: {
    fontSize: '3.6rem',
    lineHeight: '4.2rem'
  },
  xxl: {
    fontSize: '5.0rem',
    lineHeight: '5.6rem'
  }
};
var sizesMobile = {
  xxxs: {
    fontSize: '1.2rem',
    lineHeight: '1.8rem'
  },
  xxs: {
    fontSize: '1.4rem',
    lineHeight: '2.0rem'
  },
  xs: {
    fontSize: '1.6rem',
    lineHeight: '2.2rem'
  },
  sm: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem'
  },
  md: {
    fontSize: '2rem',
    lineHeight: '2.6rem'
  },
  lg: {
    fontSize: '2.4rem',
    lineHeight: '3rem'
  },
  xl: {
    fontSize: '3rem',
    lineHeight: '3.6rem'
  },
  xxl: {
    fontSize: '3.6rem',
    lineHeight: '4.2rem'
  }
};
var ProductBrand = styled.span.withConfig({
  displayName: "ProductNamestyled__ProductBrand",
  componentId: "sc-1nkczwx-0"
})(["font-size:inherit;line-height:inherit;text-transform:uppercase;color:", ";font-family:", ";"], function (props) {
  return props.darkTheme ? colors.White : colors.BlueDark;
}, function (props) {
  return getFont(props.theme, 'bold');
});
var ProductLabel = styled.span.withConfig({
  displayName: "ProductNamestyled__ProductLabel",
  componentId: "sc-1nkczwx-1"
})(["font-size:inherit;line-height:inherit;text-transform:uppercase;color:", ";font-family:", ";"], colors.BlueSky, function (props) {
  return getFont(props.theme, 'semiBold');
});
var ProductWrapper = styled.span.withConfig({
  displayName: "ProductNamestyled__ProductWrapper",
  componentId: "sc-1nkczwx-2"
})(["line-height:", ";font-size:", ";@media only screen and (min-width:768px){line-height:", ";font-size:", ";}"], function (props) {
  return props.forceMobileSize ? sizesMobile[props.forceMobileSize].lineHeight : props.size ? sizesMobile[props.size].lineHeight : 'inherit';
}, function (props) {
  return props.forceMobileSize ? sizesMobile[props.forceMobileSize].fontSize : props.size ? sizesMobile[props.size].fontSize : 'inherit';
}, function (props) {
  return props.size ? sizes[props.size].lineHeight : 'inherit';
}, function (props) {
  return props.size ? sizes[props.size].fontSize : 'inherit';
});
var ProductName = /*#__PURE__*/function (_Component) {
  _inherits(ProductName, _Component);
  var _super = _createSuper(ProductName);
  function ProductName() {
    _classCallCheck(this, ProductName);
    return _super.apply(this, arguments);
  }
  _createClass(ProductName, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        darkTheme = _this$props.darkTheme,
        size = _this$props.size,
        type = _this$props.type,
        forceMobileSize = _this$props.forceMobileSize;
      return /*#__PURE__*/React__default.createElement(ProductWrapper, {
        size: size,
        forceMobileSize: forceMobileSize
      }, type === 'uppie' ? /*#__PURE__*/React__default.createElement(ProductBrand, {
        darkTheme: darkTheme
      }, "Uppie") : /*#__PURE__*/React__default.createElement(ProductBrand, {
        darkTheme: darkTheme
      }, "KEY"), type !== 'uppie' && /*#__PURE__*/React__default.createElement(ProductLabel, {
        color: "BlueSky"
      }, type && type.replace('key', '')));
    }
  }]);
  return ProductName;
}(React.Component);
ProductName.propTypes = {
  /** The size of the text, sets both the font size and the line height. Allowed values (mobile/desktop): xxxs(12px/14px), xxs (14px/16px), xs (16px/18px), sm (18px/20px), md (20px/24px), lg (24px/30px), xl (30px/36px), xxl (36px/50px). If not passed, will switch to inherit value */
  size: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  /** keytrade products names */
  type: PropTypes.oneOf(['keyplan', 'keyprivate', 'keyhome', 'keyfunds', 'keypack', 'keypension', 'uppie']).isRequired,
  /** for dark background version */
  darkTheme: PropTypes.bool,
  /** force mobile fontsize and lineheight */
  forceMobileSize: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'])
};
ProductName.defaultProps = {
  darkTheme: false,
  forceMobileSize: null
};
exports.ProductName = ProductName;